export default {"src":"/_next/static/media/learning.97ddfdaf.svg","height":180,"width":180};